import { CAR_IMAGE_URL, PARTS } from "@/lib/parts";

// Panel hotspot coordinates (percentages over the car image).
// The image is roughly square; numbers correspond to the labels printed.
const HOTSPOTS = {
  1:  { x: 25, y: 17, w: 11, h: 10 },   // aleta del izq
  2:  { x: 64, y: 17, w: 11, h: 10 },   // aleta del der
  3:  { x: 22, y: 76, w: 11, h: 9  },   // aleta tras izq
  4:  { x: 67, y: 76, w: 11, h: 9  },   // aleta tras der
  5:  { x: 27, y: 43, w: 9,  h: 12 },   // puerta del izq
  6:  { x: 64, y: 43, w: 9,  h: 12 },   // puerta del der
  7:  { x: 27, y: 56, w: 9,  h: 12 },   // puerta tras izq
  8:  { x: 64, y: 56, w: 9,  h: 12 },   // puerta tras der
  9:  { x: 42, y: 13, w: 16, h: 14 },   // capó
  10: { x: 38, y: 45, w: 24, h: 22 },   // techo
  11: { x: 42, y: 70, w: 16, h: 6  },   // maletero alto
  12: { x: 42, y: 88, w: 16, h: 6  },   // maletero bajo
};

// Hotspots informativos (NO clicables) para montantes I/D — sirven para que
// el usuario vea la posición y el contador de bollos sobre la imagen.
const INFO_HOTSPOTS = {
  montante_izq: { x: 33, y: 38, w: 7, h: 8, label: "M·I" },
  montante_der: { x: 60, y: 38, w: 7, h: 8, label: "M·D" },
};

export default function CarPanelMap({ activeKey, onPick, dotsByKey = {} }) {
  return (
    <div className="relative w-full max-w-[420px] mx-auto select-none" data-testid="car-panel-map">
      <img src={CAR_IMAGE_URL} alt="Vista superior del vehículo" className="w-full h-auto block" />
      {/* Marcadores informativos no clicables (montantes) */}
      {Object.entries(INFO_HOTSPOTS).map(([key, h]) => {
        const dot = dotsByKey[key];
        return (
          <div
            key={key}
            data-testid={`car-info-${key}`}
            className="absolute rounded-md border border-dashed border-zinc-400/70 pointer-events-none"
            style={{
              left: `${h.x}%`, top: `${h.y}%`,
              width: `${h.w}%`, height: `${h.h}%`,
              background: "rgba(0,0,0,.04)",
            }}
            title={key}
          >
            <span className="absolute -top-2 left-1/2 -translate-x-1/2 text-[9px] font-semibold tracking-wider text-zinc-500 bg-white/80 px-1 rounded">
              {h.label}
            </span>
            {dot ? (
              <span className="absolute -top-1 -right-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-[5px] text-[10px] font-bold rounded-full bg-[var(--accent)] text-white shadow">
                {dot}
              </span>
            ) : null}
          </div>
        );
      })}
      {PARTS.filter(p => p.number !== null).map((p) => {
        const h = HOTSPOTS[p.number];
        if (!h) return null;
        const isActive = activeKey === p.key;
        const dot = dotsByKey[p.key];
        return (
          <button
            key={p.key}
            data-testid={`car-panel-${p.number}`}
            onClick={() => onPick(p.key)}
            className={`car-panel absolute rounded-md ${isActive ? "is-active" : ""}`}
            style={{
              left: `${h.x}%`, top: `${h.y}%`,
              width: `${h.w}%`, height: `${h.h}%`,
              background: isActive ? "rgba(198,58,31,.15)" : "rgba(0,0,0,.0)",
            }}
            title={`${p.number}. ${p.name}`}
            type="button"
          >
            {dot ? (
              <span className="absolute -top-1 -right-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-[5px] text-[10px] font-bold rounded-full bg-[var(--accent)] text-white shadow">
                {dot}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
